export default __webpack_public_path__ + "static/media/blitz.5460abd3.png";